import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Typography } from "@material-ui/core";
import { Color } from "../../model/answer";

const useStyles = makeStyles((theme) => ({
    answerButton: {
        flexGrow: 0.15,
        color: "white",
        textTransform: "none",
        minWidth: "70%",
    },
    center: {
        marginLeft: "15%",
        marginRight: "15%",
    },
    black: {
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            background: theme.palette.primary.main,
        },
    },
    red: {
        backgroundColor: "red !important",
    },
    green: {
        backgroundColor: "green !important",
    },
    player1: {
        marginLeft: "0%",
    },
    player2: {
        marginRight: "0%",
    },
    bothPlayers: {
        marginLeft: "0%",
        marginRight: "0%",
    },
}));

type AnswerProps = {
    id: number;
    text: string;
    color: Color;
    player1: boolean;
    player2: boolean;
    clickFunc: Function;
}

export default function AnswerPlay({ id, text, color, player1, player2, clickFunc }: AnswerProps): JSX.Element {
    const classes = useStyles();
    let colorClass = classes.black;
    if (color === Color.Green) colorClass = classes.green;
    if (color === Color.Red) colorClass = classes.red;

    let playerClass = "";
    playerClass += player1 ? `${classes.player1} ` : "";
    playerClass += player2 ? `${classes.player2}` : "";


    return (
        <Button
            className={`${colorClass} ${playerClass} ${classes.answerButton} ${classes.center}`} onClick={() => clickFunc(id)}
        >
            <Typography variant="h5">
                {text}
            </Typography>
        </Button>
    );
}
